import { Input as AInput, Modal as AModal, Col, Row } from 'antd';
import Form, { Item } from '../Form/Form';
import { FormattedMessage, injectIntl } from 'react-intl';
import React, { Component } from 'react';

import { Avatar } from '../Company/Avatar';
import { Box } from '../Box/Box';
import Input from 'components/TrackingComponents/Input';
import TrackingButton from 'components/TrackingComponents/Button';
import messages from 'containers/StoreInfoPage/messages';
import styled from 'styled-components';
import utilsMessages from 'utils/messages';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import formatFullAddress from 'utils/formatFullAddress';
import { Location } from 'types/schema';

const Button = styled(TrackingButton)<any>``;
const TextArea = styled(AInput.TextArea)<any>``;

const InfoContainer = styled.div`
  margin-bottom: 12px;
`;

const DeleteBtnContainer = styled.div`
  ${Button} {
    border-color: transparent;
    :hover,
    :active,
    :focus {
      border-color: transparent;
    }
  }
`;

const Side = styled(Box)``;

const Body = styled.div``;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
`;

const Label = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #979b95;
`;

const Value = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #2f382c;
  word-break: break-word;
`;

const UpdateMessageForm = styled(Form)``;
const FormRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const Heading = styled.h3`
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 6pt;
  font-weight: 600;
  text-transform: uppercase;
  color: #2f382c;
`;

const Actions = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

const Divider = styled.div`
  height: 1px;
  background-color: #d9d9d9;
  margin: 16px 0;
`;

class Store extends Component<{
  intl: any;
  store: any;
  deliveryNotes: any[];
  onDeleteDeliveryMessage: (item: any) => void;
  onUpdateDeliveryMessage: (items: any) => void;
  onUpdateStore: (items: any) => void;
  onUpdateDeliveryMessages: (data: any) => void;
}> {
  public state = {
    notes: [...this.props.deliveryNotes],
    imageUrl: this.props.store.imageUrl || '',
    edited: false,
    formRef: React.createRef(),
  };

  public componentWillReceiveProps(nextProps: any) {
    this.setState({
      notes: [...nextProps.deliveryNotes],
    });
  }

  public setOpenEditModal = (value: any) => {
    this.setState({
      ...this.state,
      isOpenEditModal: value,
    });
  };

  public onSetImageUrl = (url: string) => this.setState({ ...this.state, imageUrl: url });

  public setNotes = (value: any) => {
    this.setState({
      ...this.state,
      notes: value,
      edited: true,
    });
  };
  public onDeleteDeliveryMessageItem = (item: any, index: number) => () => {
    const cancelOrderMessage = this.props.intl.formatMessage(messages.deleteDeliveryNoteMessage);
    const yes = this.props.intl.formatMessage(utilsMessages.yes);
    const no = this.props.intl.formatMessage(utilsMessages.no);
    AModal.confirm({
      autoFocusButton: null,
      okButtonProps: {
        danger: true,
      },
      title: cancelOrderMessage,
      okText: yes,
      cancelText: no,
      onOk: () => {
        const { notes } = this.state;
        if (item.id) {
          this.props.onDeleteDeliveryMessage(item);
        }
        notes.splice(index, 1);
        this.setNotes(notes);
      },
    });
  };
  public saveNotes = () => {
    const { deliveryNotes } = this.props;
    const { notes } = this.state;
    const createNotes: any[] = [];
    const updateNotes: any[] = [];
    notes.forEach((note, index) => {
      if (!note.id && note.text.trim()) {
        createNotes.push(note);
      }
      if (deliveryNotes[index] && deliveryNotes[index].text !== note.text && note.id) {
        updateNotes.push(note);
      }
    });
    this.props.onUpdateDeliveryMessages({
      createNotes: createNotes,
      updateNotes: updateNotes,
    });
    this.setState({
      ...this.state,
      edited: false,
    });
  };

  public onChangeDelivryNotes = (index) => (event: any) => {
    const { notes } = this.state;
    notes[index] = {
      ...notes[index],
      text: event.target.value,
    };
    this.setNotes(notes);
  };

  public onAddMoreNote = () => {
    const { notes } = this.state;
    this.setNotes([...notes, { text: '' }]);
  };

  public render() {
    const { store } = this.props;
    const { notes } = this.state;
    const alternativeImage = (name) => `https://ui-avatars.com/api/?name=${name}&size=512`;
    return (
      <Row gutter={8}>
        <Col lg={7} xs={24}>
          <Side>
            <Avatar src={store.imageUrl || alternativeImage(store.name)} disabled={true} />
            <InfoContainer>
              <Heading>
                <FormattedMessage {...messages.header} />
              </Heading>
              <Info>
                <Label>
                  <FormattedMessage {...messages.name} />
                </Label>
                <Value>{store.name}</Value>
              </Info>
              <Info>
                <Label>
                  <FormattedMessage {...messages.address} />
                </Label>
                <Value>
                  {formatFullAddress({
                    ...(store?.newMergedLocation as Location),
                    noteForAddress: store?.addressNote?.trim() || '',
                  })}
                </Value>
              </Info>
              <Info>
                <Label>
                  <FormattedMessage {...messages.phone} />
                </Label>
                <Value>{store.telephone}</Value>
              </Info>
            </InfoContainer>
            <Divider />
            <InfoContainer>
              <Heading>
                <FormattedMessage {...messages.redInvoiceInfo} />
              </Heading>
              <Info>
                <Label>
                  <FormattedMessage {...messages.taxCode} />
                </Label>
                <Value>{store?.redInvoice?.mst}</Value>
              </Info>
              <Info>
                <Label>
                  <FormattedMessage {...messages.companyName} />
                </Label>
                <Value>{store?.redInvoice?.companyName}</Value>
              </Info>
              <Info>
                <Label>
                  <FormattedMessage {...messages.redInvoiceInfoEmail} />
                </Label>
                <Value>{store?.redInvoice?.email}</Value>
              </Info>
              <Info>
                <Label>
                  <FormattedMessage {...messages.address} />
                </Label>
                <Value>{store?.redInvoice?.address}</Value>
              </Info>
            </InfoContainer>
          </Side>
        </Col>
        <Col lg={17} xs={24}>
          <Body>
            <Box>
              <Heading>
                <FormattedMessage {...messages.deliveryMessages} />
              </Heading>
              <UpdateMessageForm>
                {notes.map((dn: any, index) => (
                  <Item key={dn.id || index}>
                    <FormRow>
                      <Input
                        InputComponent={TextArea}
                        trackingCategory="Store | Input"
                        trackingAction="Enter Delivery Message"
                        value={dn.text}
                        onChange={this.onChangeDelivryNotes(index)}
                      />
                      <DeleteBtnContainer>
                        <Button
                          trackingCategory="Store | Button"
                          trackingAction="Attempt to Delete Delivery Message"
                          type="danger"
                          icon={<DeleteOutlined />}
                          size="small"
                          style={{ color: 'rgba(0,0,0,0.54)' }}
                          ghost
                          onClick={this.onDeleteDeliveryMessageItem(dn, index)}
                        />
                      </DeleteBtnContainer>
                    </FormRow>
                  </Item>
                ))}
                <Actions>
                  <Button
                    trackingCategory="Store | Button"
                    trackingAction="Add More Delivery Message"
                    onClick={this.onAddMoreNote}
                    icon={<PlusOutlined />}
                    type="link"
                    size="small"
                  >
                    <FormattedMessage {...messages.addMore} />
                  </Button>
                </Actions>
                <Button
                  trackingCategory="Store | Button"
                  trackingAction="Save Delivery Message"
                  disabled={!this.state.edited}
                  type="primary"
                  onClick={this.saveNotes}
                >
                  <FormattedMessage {...messages.save} />
                </Button>
              </UpdateMessageForm>
            </Box>
          </Body>
        </Col>
      </Row>
    );
  }
}

export default injectIntl(Store);
